import Cookies from 'universal-cookie';
import { isNil, get, has, merge, isEmpty } from 'lodash';
import axios from 'axios';
import { call, put, select, all, take, takeEvery, takeLatest } from 'redux-saga/effects';

var SET_USER_TOKEN = 'SET_USER_TOKEN';
var LOAD_USER = 'LOAD_USER';
var LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
var LOAD_USER_ERROR = 'LOAD_USER_ERROR';
var LOGIN = 'LOGIN';
var SIGNUP = 'SIGNUP';
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
var SIGNUP_ERROR = 'SIGNUP_ERROR';
var LOGIN_ERROR = 'LOGIN_ERROR';
var PATCH_USER = 'PATCH_USER';
var PATCH_USER_MULTIPART = 'PATCH_USER/PATCH_USER_MULTIPART';
var PATCH_USER_SUCCESS = 'PATCH_USER_SUCCESS';
var PATCH_USER_ERROR = 'PATCH_USER_ERROR';
var LOGOUT = 'LOGOUT';
var CLEAR_ERRORS = 'CLEAR_ERRORS';

var setUserToken = function setUserToken(token) {
  return {
    type: SET_USER_TOKEN,
    token: token
  };
};

var login = function login(formData) {
  return {
    type: LOGIN,
    formData: formData
  };
};

var logout = function logout(params) {
  return {
    type: LOGOUT,
    params: params
  };
};

var signup = function signup(formData) {
  return {
    type: SIGNUP,
    formData: formData
  };
};

var patchUser = function patchUser(formData, headers, toast) {
  return {
    type: PATCH_USER,
    formData: formData,
    headers: headers,
    toast: toast
  };
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var initialState = {
  user: null,
  token: null,
  userLoading: false,
  loadUserError: null,
  loginPending: false,
  loginError: null,
  signupPending: false,
  signupError: null,
  patchUserError: null
};

var account = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case SET_USER_TOKEN:
      return _extends({}, state, {
        token: action.token
      });
    case SIGNUP:
      return _extends({}, state, {
        signupPending: true
      });
    case SIGNUP_SUCCESS:
      return _extends({}, state, {
        signupPending: false,
        signupError: null,
        user: action.user,
        token: action.key
      });
    case SIGNUP_ERROR:
      return _extends({}, state, {
        signupPending: false,
        signupError: action.error
      });
    case LOGIN:
      return _extends({}, state, {
        loginPending: true
      });
    case LOGIN_SUCCESS:
      return _extends({}, state, {
        loginPending: false,
        loginError: null,
        user: action.user,
        token: action.key
      });
    case LOGIN_ERROR:
      return _extends({}, state, {
        loginPending: false,
        loginError: action.error
      });
    case PATCH_USER:
      return _extends({}, state, {
        userLoading: true
      });
    case PATCH_USER_SUCCESS:
      return _extends({}, state, {
        userLoading: false,
        patchUserError: null,
        user: action.response
      });
    case PATCH_USER_ERROR:
      return _extends({}, state, {
        userLoading: false,
        patchUserError: action.error
      });
    case LOAD_USER:
      return _extends({}, state, {
        userLoading: true
      });
    case LOAD_USER_SUCCESS:
      return _extends({}, state, {
        userLoading: false,
        user: action.user
      });
    case LOAD_USER_ERROR:
      return _extends({}, state, {
        userLoading: false
      });
    case LOGOUT:
      return _extends({}, state, {
        user: null,
        token: null
      });
    case CLEAR_ERRORS:
      return _extends({}, state, {
        signupError: null,
        loginError: null,
        loadUserError: null
      });
    default:
      return state;
  }
});

var SET_ENV = 'ENV/SET_ENV';

var setEnv = function setEnv(envData) {
  return _extends({
    type: SET_ENV
  }, envData);
};

var initialState$1 = {
  api_domain: '',
  api_root: '',
  token_name: '',
  token_type: '',
  esRoot: ''
};

var env = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments[1];

  switch (action.type) {
    case SET_ENV:
      return _extends({}, state, {
        api_domain: action.api_domain,
        api_root: action.api_root,
        token_name: action.token_name,
        token_type: action.token_type,
        esRoot: action.esRoot
      });

    default:
      return state;
  }
});

var getUser = function getUser(_ref) {
  var account = _ref.account;
  return account ? account.user : null;
};

var getToken = function getToken(_ref2) {
  var account = _ref2.account,
      env = _ref2.env;

  if (!!account.token) {
    return account.token;
  } else if (!!env.token_name) {
    return new Cookies().get(env.token_name);
  } else {
    return null;
  }
};

var getApiRoot = function getApiRoot(_ref) {
  var env = _ref.env;
  return env ? env.api_root : null;
};

var getTokenName = function getTokenName(_ref2) {
  var env = _ref2.env;
  return env ? env.token_name : null;
};
var getTokenType = function getTokenType(_ref3) {
  var env = _ref3.env;
  return get(env, 'token_type') ? env.token_type : 'Token';
};

var UNAUTHORIZED_REQUEST = 401;

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getHeaders),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(apiPost),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(apiGet),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(apiPut),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(apiPatch),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(apiDelete);

var parseOptions = function parseOptions(options) {
  var data = null;
  var customHeaders = undefined;
  var authenticationRequired = true;

  var hasData = has(options, 'data');
  var hasHeaders = has(options, 'headers');
  var hasAuthRequired = has(options, 'authenticationRequired');

  if (hasData || hasHeaders || hasAuthRequired) {
    if (hasData) {
      data = get(options, 'data');
    }

    if (hasHeaders) {
      customHeaders = get(options, 'headers');
    }

    if (hasAuthRequired) {
      authenticationRequired = get(options, 'authenticationRequired');
    }
  } else {
    data = options;
  }

  return { data: data, customHeaders: customHeaders, authenticationRequired: authenticationRequired };
};

var validateStatus = function validateStatus() {
  return true;
};

function getHeaders(options) {
  var headers, authenticationRequired, customHeaders, token, token_type;
  return regeneratorRuntime.wrap(function getHeaders$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          headers = {
            'Content-Type': 'application/json'
          };
          authenticationRequired = get(options, 'authenticationRequired', true);
          customHeaders = get(options, 'customHeaders', {});

          if (!authenticationRequired) {
            _context.next = 11;
            break;
          }

          _context.next = 6;
          return select(getToken);

        case 6:
          token = _context.sent;
          _context.next = 9;
          return select(getTokenType);

        case 9:
          token_type = _context.sent;


          if (token) {
            headers['Authorization'] = token_type + ' ' + token;
          }

        case 11:
          return _context.abrupt('return', merge({}, headers, customHeaders));

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function apiPost(path, options) {
  var _parseOptions, data, customHeaders, authenticationRequired, headers, apiRoot, response;

  return regeneratorRuntime.wrap(function apiPost$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _parseOptions = parseOptions(options), data = _parseOptions.data, customHeaders = _parseOptions.customHeaders, authenticationRequired = _parseOptions.authenticationRequired;
          _context2.next = 3;
          return call(getHeaders, {
            authenticationRequired: authenticationRequired,
            customHeaders: customHeaders
          });

        case 3:
          headers = _context2.sent;
          _context2.next = 6;
          return select(getApiRoot);

        case 6:
          apiRoot = _context2.sent;
          _context2.next = 9;
          return axios.post(apiRoot + '/' + path, data, {
            headers: headers,
            validateStatus: validateStatus
          });

        case 9:
          response = _context2.sent;

          if (!(response.status === UNAUTHORIZED_REQUEST)) {
            _context2.next = 21;
            break;
          }

          _context2.prev = 11;

          if (!(response.data.detail === 'Token has expired')) {
            _context2.next = 16;
            break;
          }

          _context2.next = 15;
          return put({
            type: LOGOUT,
            message: 'session-timeout'
          });

        case 15:
          return _context2.abrupt('return');

        case 16:
          _context2.next = 21;
          break;

        case 18:
          _context2.prev = 18;
          _context2.t0 = _context2['catch'](11);

          console.log('err', _context2.t0);

        case 21:
          if (!(response.status > 299)) {
            _context2.next = 23;
            break;
          }

          return _context2.abrupt('return', response);

        case 23:
          return _context2.abrupt('return', get(response, 'data', response));

        case 24:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[11, 18]]);
}

function apiGet(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _parseOptions2, data, customHeaders, authenticationRequired, headers, apiRoot, url, queryString, response;

  return regeneratorRuntime.wrap(function apiGet$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _parseOptions2 = parseOptions(options), data = _parseOptions2.data, customHeaders = _parseOptions2.customHeaders, authenticationRequired = _parseOptions2.authenticationRequired;
          _context3.next = 3;
          return call(getHeaders, {
            authenticationRequired: authenticationRequired,
            customHeaders: customHeaders
          });

        case 3:
          headers = _context3.sent;
          _context3.next = 6;
          return select(getApiRoot);

        case 6:
          apiRoot = _context3.sent;
          url = apiRoot + '/' + path;


          if (!isEmpty(data)) {
            queryString = Object.keys(data).map(function (key) {
              return key + '=' + data[key];
            }).join('&');

            url = url + '?' + queryString;
          }

          // Always return true so error status 4xx promises aren't rejected.
          _context3.next = 11;
          return axios.get(url, { headers: headers, validateStatus: validateStatus });

        case 11:
          response = _context3.sent;

          if (!(response.status === UNAUTHORIZED_REQUEST)) {
            _context3.next = 26;
            break;
          }

          _context3.prev = 13;

          if (!(response.data.detail === 'Token has expired')) {
            _context3.next = 19;
            break;
          }

          _context3.next = 17;
          return put({
            type: LOGOUT,
            message: 'session-timeout'
          });

        case 17:
          _context3.next = 21;
          break;

        case 19:
          _context3.next = 21;
          return put({
            type: LOGOUT
          });

        case 21:
          _context3.next = 26;
          break;

        case 23:
          _context3.prev = 23;
          _context3.t0 = _context3['catch'](13);

          console.log('err', _context3.t0);

        case 26:
          if (!(response.status > 299)) {
            _context3.next = 28;
            break;
          }

          return _context3.abrupt('return', response);

        case 28:
          return _context3.abrupt('return', get(response, 'data', response));

        case 29:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[13, 23]]);
}

function apiPut(path, options) {
  var _parseOptions3, data, customHeaders, authenticationRequired, headers, apiRoot, url, response;

  return regeneratorRuntime.wrap(function apiPut$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _parseOptions3 = parseOptions(options), data = _parseOptions3.data, customHeaders = _parseOptions3.customHeaders, authenticationRequired = _parseOptions3.authenticationRequired;
          _context4.next = 3;
          return call(getHeaders, {
            authenticationRequired: authenticationRequired,
            customHeaders: customHeaders
          });

        case 3:
          headers = _context4.sent;
          _context4.next = 6;
          return select(getApiRoot);

        case 6:
          apiRoot = _context4.sent;
          url = apiRoot + '/' + path;

          // Always return true so error status 4xx promises aren't rejected.

          _context4.next = 10;
          return axios.put(url, data, { headers: headers, validateStatus: validateStatus });

        case 10:
          response = _context4.sent;

          if (!(response.status === UNAUTHORIZED_REQUEST)) {
            _context4.next = 25;
            break;
          }

          _context4.prev = 12;

          if (!(response.data.detail === 'Token has expired')) {
            _context4.next = 18;
            break;
          }

          _context4.next = 16;
          return put({
            type: LOGOUT,
            message: 'session-timeout'
          });

        case 16:
          _context4.next = 20;
          break;

        case 18:
          _context4.next = 20;
          return put({
            type: LOGOUT
          });

        case 20:
          _context4.next = 25;
          break;

        case 22:
          _context4.prev = 22;
          _context4.t0 = _context4['catch'](12);

          console.log('err', _context4.t0);

        case 25:
          if (!(response.status > 299)) {
            _context4.next = 27;
            break;
          }

          return _context4.abrupt('return', response);

        case 27:
          return _context4.abrupt('return', get(response, 'data', response));

        case 28:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[12, 22]]);
}

function apiPatch(path, options) {
  var _parseOptions4, data, customHeaders, authenticationRequired, headers, apiRoot, url, response;

  return regeneratorRuntime.wrap(function apiPatch$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _parseOptions4 = parseOptions(options), data = _parseOptions4.data, customHeaders = _parseOptions4.customHeaders, authenticationRequired = _parseOptions4.authenticationRequired;
          _context5.next = 3;
          return call(getHeaders, {
            authenticationRequired: authenticationRequired,
            customHeaders: customHeaders
          });

        case 3:
          headers = _context5.sent;
          _context5.next = 6;
          return select(getApiRoot);

        case 6:
          apiRoot = _context5.sent;
          url = apiRoot + '/' + path;

          // Always return true so error status 4xx promises aren't rejected.

          _context5.next = 10;
          return axios.patch(url, data, { headers: headers, validateStatus: validateStatus });

        case 10:
          response = _context5.sent;

          if (!(response.status === UNAUTHORIZED_REQUEST)) {
            _context5.next = 25;
            break;
          }

          _context5.prev = 12;

          if (!(response.data.detail === 'Token has expired')) {
            _context5.next = 18;
            break;
          }

          _context5.next = 16;
          return put({
            type: LOGOUT,
            message: 'session-timeout'
          });

        case 16:
          _context5.next = 20;
          break;

        case 18:
          _context5.next = 20;
          return put({
            type: LOGOUT
          });

        case 20:
          _context5.next = 25;
          break;

        case 22:
          _context5.prev = 22;
          _context5.t0 = _context5['catch'](12);

          console.log('err', _context5.t0);

        case 25:
          if (!(response.status > 299)) {
            _context5.next = 27;
            break;
          }

          return _context5.abrupt('return', response);

        case 27:
          return _context5.abrupt('return', get(response, 'data', response));

        case 28:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[12, 22]]);
}

function apiDelete(path) {
  var authenticationRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var headers, apiRoot, url, response;
  return regeneratorRuntime.wrap(function apiDelete$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return call(getHeaders, { authenticationRequired: authenticationRequired });

        case 2:
          headers = _context6.sent;
          _context6.next = 5;
          return select(getApiRoot);

        case 5:
          apiRoot = _context6.sent;
          url = apiRoot + '/' + path;
          _context6.next = 9;
          return axios.delete(url, { headers: headers });

        case 9:
          response = _context6.sent;

          if (!(response.status === UNAUTHORIZED_REQUEST)) {
            _context6.next = 24;
            break;
          }

          _context6.prev = 11;

          if (!(response.data.detail === 'Token has expired')) {
            _context6.next = 17;
            break;
          }

          _context6.next = 15;
          return put({
            type: LOGOUT,
            message: 'session-timeout'
          });

        case 15:
          _context6.next = 19;
          break;

        case 17:
          _context6.next = 19;
          return put({
            type: LOGOUT
          });

        case 19:
          _context6.next = 24;
          break;

        case 21:
          _context6.prev = 21;
          _context6.t0 = _context6['catch'](11);

          console.log('err', _context6.t0);

        case 24:
          if (!(response.status > 299)) {
            _context6.next = 26;
            break;
          }

          return _context6.abrupt('return', response);

        case 26:
          return _context6.abrupt('return', get(response, 'data', response));

        case 27:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[11, 21]]);
}

var api = {
  login: function login$$1(data) {
    return apiPost('api/login/', { data: data, authenticationRequired: false });
  },
  signup: function signup$$1(data) {
    return apiPost('api/signup/', { data: data, authenticationRequired: false });
  },
  patchUser: function patchUser$$1(data, headers) {
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'api/user/';

    return apiPatch(path, { data: data, headers: headers });
  },
  loadUser: function loadUser() {
    return apiGet('api/user/');
  }
};

var _marked$1 = /*#__PURE__*/regeneratorRuntime.mark(minDelayCall);

var delay = function delay(ms) {
  return new Promise(function (res) {
    return setTimeout(res, ms);
  });
};

// Take at least 500ms.
function minDelayCall() {
  var _ref,
      _ref2,
      result,
      _args = arguments;

  return regeneratorRuntime.wrap(function minDelayCall$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([call.apply(undefined, _args), call(delay, 500)]);

        case 2:
          _ref = _context.sent;
          _ref2 = slicedToArray(_ref, 1);
          result = _ref2[0];
          return _context.abrupt('return', result);

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked$1, this);
}

var _marked$2 = /*#__PURE__*/regeneratorRuntime.mark(doSignup),
    _marked2$1 = /*#__PURE__*/regeneratorRuntime.mark(doLogin),
    _marked3$1 = /*#__PURE__*/regeneratorRuntime.mark(loadUser),
    _marked4$1 = /*#__PURE__*/regeneratorRuntime.mark(doPatchUser),
    _marked5$1 = /*#__PURE__*/regeneratorRuntime.mark(loginFlow),
    _marked6$1 = /*#__PURE__*/regeneratorRuntime.mark(doLogOut),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(_callee);

function doSignup(action$$1) {
  var formData, response, tokenName;
  return regeneratorRuntime.wrap(function doSignup$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          formData = action$$1.formData;
          _context.prev = 1;
          _context.next = 4;
          return minDelayCall(api.signup, formData);

        case 4:
          response = _context.sent;

          if (!(!isNil(response.status) && response.status > 299)) {
            _context.next = 10;
            break;
          }

          _context.next = 8;
          return put({
            type: SIGNUP_ERROR,
            error: get(response, 'data')
          });

        case 8:
          _context.next = 17;
          break;

        case 10:
          response['nextRoute'] = formData.nextRoute;

          // Persist token for future page loads
          _context.next = 13;
          return select(getTokenName);

        case 13:
          tokenName = _context.sent;

          new Cookies().set(tokenName, response.key, { path: '/' });

          _context.next = 17;
          return put(_extends({ type: SIGNUP_SUCCESS }, response));

        case 17:
          _context.next = 23;
          break;

        case 19:
          _context.prev = 19;
          _context.t0 = _context['catch'](1);
          _context.next = 23;
          return put({ type: SIGNUP_ERROR, error: get(_context.t0, 'response.data', _context.t0) });

        case 23:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked$2, this, [[1, 19]]);
}

function doLogin(action$$1) {
  var formData, response, tokenName;
  return regeneratorRuntime.wrap(function doLogin$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          formData = action$$1.formData;
          _context2.prev = 1;
          _context2.next = 4;
          return minDelayCall(api.login, formData);

        case 4:
          response = _context2.sent;

          if (!(!isNil(response.status) && response.status > 299)) {
            _context2.next = 10;
            break;
          }

          _context2.next = 8;
          return put({
            type: LOGIN_ERROR,
            error: get(response, 'data')
          });

        case 8:
          _context2.next = 17;
          break;

        case 10:
          response['nextRoute'] = formData.nextRoute;

          // Persist token for future page loads
          _context2.next = 13;
          return select(getTokenName);

        case 13:
          tokenName = _context2.sent;

          new Cookies().set(tokenName, response.key, { path: '/' });

          _context2.next = 17;
          return put(_extends({ type: LOGIN_SUCCESS }, response));

        case 17:
          _context2.next = 23;
          break;

        case 19:
          _context2.prev = 19;
          _context2.t0 = _context2['catch'](1);
          _context2.next = 23;
          return put({ type: LOGIN_ERROR, error: get(_context2.t0, 'response.data', _context2.t0) });

        case 23:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2$1, this, [[1, 19]]);
}

function loadUser() {
  var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var user, tokenName;
  return regeneratorRuntime.wrap(function loadUser$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put({ type: LOAD_USER });

        case 2:
          _context3.prev = 2;

          if (!token) {
            _context3.next = 6;
            break;
          }

          _context3.next = 6;
          return put(setUserToken(token));

        case 6:
          _context3.next = 8;
          return select(getToken);

        case 8:
          if (!_context3.sent) {
            _context3.next = 16;
            break;
          }

          _context3.next = 11;
          return minDelayCall(api.loadUser);

        case 11:
          user = _context3.sent;
          _context3.next = 14;
          return put({ type: LOAD_USER_SUCCESS, user: user });

        case 14:
          _context3.next = 18;
          break;

        case 16:
          _context3.next = 18;
          return put({ type: LOAD_USER_ERROR });

        case 18:
          _context3.next = 28;
          break;

        case 20:
          _context3.prev = 20;
          _context3.t0 = _context3['catch'](2);
          _context3.next = 24;
          return select(getTokenName);

        case 24:
          tokenName = _context3.sent;

          new Cookies().remove(tokenName, { path: '/' });

          _context3.next = 28;
          return put({ type: LOAD_USER_ERROR });

        case 28:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3$1, this, [[2, 20]]);
}

function doPatchUser(action$$1) {
  var formData, headers, toast, response;
  return regeneratorRuntime.wrap(function doPatchUser$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          formData = action$$1.formData, headers = action$$1.headers, toast = action$$1.toast;
          _context4.next = 3;
          return call(api.patchUser, formData, headers);

        case 3:
          response = _context4.sent;

          if (!(!isNil(response.status) && response.status > 299)) {
            _context4.next = 9;
            break;
          }

          _context4.next = 7;
          return put({
            type: PATCH_USER_ERROR,
            error: get(response, 'data')
          });

        case 7:
          _context4.next = 12;
          break;

        case 9:
          _context4.next = 11;
          return put({ type: PATCH_USER_SUCCESS, response: response });

        case 11:
          if (toast) {
            toast.success('User value has been updated', {
              bodyClassName: 'toast-body',
              style: {
                backgroundColor: '#414B4F',
                color: '#ffffff'
              },
              progressStyle: {
                background: '#00c9b7'
              },
              position: 'bottom-right'
            });
          }

        case 12:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4$1, this);
}

// Finite state machine for user session
function loginFlow() {
  var tokenName, token, action$$1, _tokenName;

  return regeneratorRuntime.wrap(function loginFlow$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:

          _context5.next = 3;
          return select(getTokenName);

        case 3:
          tokenName = _context5.sent;
          token = new Cookies().get(tokenName);

          if (!token) {
            _context5.next = 8;
            break;
          }

          _context5.next = 8;
          return call(loadUser, token);

        case 8:
          _context5.next = 10;
          return select(getUser);

        case 10:
          if (_context5.sent) {
            _context5.next = 25;
            break;
          }

          _context5.next = 13;
          return take([LOGIN, SIGNUP, SET_USER_TOKEN]);

        case 13:
          action$$1 = _context5.sent;
          _context5.t0 = action$$1.type;
          _context5.next = _context5.t0 === LOGIN ? 17 : _context5.t0 === SIGNUP ? 20 : _context5.t0 === SET_USER_TOKEN ? 23 : 25;
          break;

        case 17:
          _context5.next = 19;
          return call(doLogin, action$$1);

        case 19:
          return _context5.abrupt('break', 25);

        case 20:
          _context5.next = 22;
          return call(doSignup, action$$1);

        case 22:
          return _context5.abrupt('break', 25);

        case 23:
          _context5.next = 25;
          return call(loadUser);

        case 25:
          _context5.next = 27;
          return select(getUser);

        case 27:
          if (!_context5.sent) {
            _context5.next = 34;
            break;
          }

          _context5.next = 30;
          return take(LOGOUT);

        case 30:
          _context5.next = 32;
          return select(getTokenName);

        case 32:
          _tokenName = _context5.sent;

          new Cookies().remove(_tokenName, { path: '/' });

        case 34:
          _context5.next = 0;
          break;

        case 36:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5$1, this);
}

function doLogOut(params) {
  var paramsType;
  return regeneratorRuntime.wrap(function doLogOut$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          paramsType = get(params, 'params.type', false);

          if (!(paramsType === 'token-invalidation')) {
            _context6.next = 4;
            break;
          }

          _context6.next = 4;
          return cancel(loginFlow);

        case 4:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6$1, this);
}

function _callee() {
  return regeneratorRuntime.wrap(function _callee$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return all([loginFlow(), takeEvery(PATCH_USER, doPatchUser), takeLatest(LOGOUT, doLogOut)]);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

export { account as accountReducer, env as envReducer, _callee as accountSagas, api, apiPost, apiGet, apiPut, apiPatch, apiDelete, getUser, getToken, getApiRoot, getTokenName, getTokenType, SET_USER_TOKEN, LOAD_USER, LOAD_USER_SUCCESS, LOAD_USER_ERROR, LOGIN, SIGNUP, LOGIN_SUCCESS, SIGNUP_SUCCESS, SIGNUP_ERROR, LOGIN_ERROR, PATCH_USER, PATCH_USER_MULTIPART, PATCH_USER_SUCCESS, PATCH_USER_ERROR, LOGOUT, CLEAR_ERRORS, setUserToken, login, logout, signup, patchUser, SET_ENV, setEnv };
//# sourceMappingURL=index.es.js.map
